import { render, staticRenderFns } from "./AssumeButton.vue?vue&type=template&id=bf798704&"
import script from "./AssumeButton.vue?vue&type=script&lang=js&"
export * from "./AssumeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports